<template>
  <div class="">
    <PageHeader label="Application sent"></PageHeader>
    
    <template v-if="$store.state.view == 'broker'">
      <div class="mt-6">
        <div class="text-base">
          Application form has been successfully sent to client.
          Click here to 
          <router-link :to="{ name : 'client-list' }"
            tag="a" class="text-blue-600">go back to the client list</router-link> page.
        </div>
      </div>

      <!-- <ShareBox /> -->

      <div class="mt-12">
        <Referral />
        <!-- <label class="label-standard">
          How are you finding {{ getAppName }}? Is there anything we can do to help you more?
        </label>

        <div class="mt-2 text-base">
          Please let us know if there is anything we can do to improve.
        </div>

        <div class="mt-4">
          <textarea v-model="message" class="input-standard h-32"></textarea>
          <div v-if="messageError !== null" class="text-red-600 mt-1 text-sm">{{ messageError }}</div>
        </div>

        <div class="mt-4">
          <SubmitButton :onClick="submit" :loading="loading" label="Submit"></SubmitButton>
        </div> -->


      </div>
    </template>

    <template v-else>
      <div class="text-base mt-8">
        Thank you for your submission.
      </div>

      <div class="text-base mt-4">
        You have filled out all the information required for your loan application.
      </div>

      <div class="text-base mt-2">
        An email has been sent to let your broker know that you have finished.
      </div>

      <div class="text-base mt-2">
        If you wish to contact them in the meantime, their details are as follows.
      </div>

      <div class="mt-8 text-base p-4 bg-gray-200 inline-block">
        <div class="">
          {{ $store.state[$store.state.view + 'Module'].broker.phone_mobile }}
        </div>

        <div class="mt-2">
          <a :href="'mailto:' + $store.state.clientModule.broker.email"
            class="no-underline text-blue-600">{{ $store.state.clientModule.broker.email }}</a>
        </div>
      </div>



      <div class="mt-12 bg-gray-200 p-4 w-1/2">
        <label class="label-standard">
          How did you find this site? Is there anything we can do to help you more?
        </label>

        <div class="mt-2 text-base">
          Please let us know if there is anything we can do to improve.
        </div>

        <div class="mt-4">
          <textarea v-model="message" class="input-standard h-32"></textarea>
          <div v-if="messageError !== null" class="text-red-600 mt-1 text-sm">{{ messageError }}</div>
        </div>

        <div class="mt-4">
          <SubmitButton :onClick="submit" :loading="loading" label="Submit"></SubmitButton>
        </div>
      </div>
    </template>

    <br/><br/><br/><br/>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import PageHeader     from '@/shared/components/headers/PageHeader'
  import ShareBox       from '@/shared/components/ShareBox'
  import SubmitButton   from '@/shared/components/form/SubmitButton'
  import Referral       from '@/shared/components/Referral'

  export default {
    components: {
      PageHeader,
      ShareBox,
      SubmitButton,
      Referral
    },

    data() {
      return {
        loading     : false,
        message     : null,
        messageError: null
      }
    },

    created() {
      if(this.$store.state.view == 'broker') {
        this.getBroker({
          force   : true,
          brokerId: this.$store.state.brokerModule.broker.id
        }, (broker) => {

        })
      }
    },

    methods : {
      submit() {
        let valid         = true
        this.messageError = null

        if(this.message == null || this.message.length == 0) {
          this.messageError = "Please type a valid feedback message."
          valid = false;
        }

        if(valid) {
          this.apiPost({
            message : this.message,
            clientId: this.$route.params.clientId
          }, 'common/feedback', () => {
            this.message = null
            EventBus.$emit('notification-event', {
              'type'   : 'success',
              'message': "Thank you."
            })
          })
        }
      }
    }
  }
</script>